import SelectInput from "../../components/SelectInput";
import DateInput from "../../components/DateInput";
import SearchButton from "../../components/SearchButton";
import RefreshButton from "../../components/RefreshButton";
import { useState } from "react";
import { BarsArrowUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import { Disclosure } from "@headlessui/react";

const TableFilters = ({
  carrierOptions,
  stateOptions,
  feeLevelOptions,
  policyTermOptions,
  handleSearchInputs,
  filterPolicyFee,
  setResetStatus,
  setFilterStatus,
  feeTypeData,
}) => {
  const [searchCarriers, setSearchCarriers] = useState("");
  const [searchStates, setSearchStates] = useState("");
  const [searchPolicyTerm, setsearchPolicyTerm] = useState("");
  const [feeType, setFeeType] = useState("");
  const [feeLevel, setFeeLevel] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateto] = useState("");

  const refreshFilterTable = () => {
    setFilterStatus(false);
    setSearchCarriers("");
    setSearchStates("");
    setsearchPolicyTerm("");
    setFeeType("");
    setFeeLevel("");
    setDateFrom("");
    setDateto("");
    handleSearchInputs("Refresh", "");
  };
  return (
    <div className="pt-1 space-y-2">
      <div>
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full ">
        <div className="mb-3">
          <Disclosure defaultOpen>
            {({ open }) => (
              <>
                <Disclosure.Button className="flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span>Policy Fee Details</span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>

                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="">
                    <div className="flex flex-col text-xs gap-y-2 p-3 sm:px-2 md:px-3 -mt-2">
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Carriers
                        </label>
                        <SelectInput
                          options={carrierOptions}
                          value={searchCarriers}
                          onChange={(e) => {
                            setSearchCarriers(e);
                            handleSearchInputs(
                              "CarrierName",
                              e !== null ? e.label : ""
                            );
                            setResetStatus(false);
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          State
                        </label>
                        <SelectInput
                          options={stateOptions}
                          value={searchStates}
                          onChange={(e) => {
                            setSearchStates(e);
                            handleSearchInputs(
                              "State",
                              e !== null ? e.label : ""
                            );
                            setResetStatus(false);
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Fee Type
                        </label>
                        <SelectInput
                          name="FeeType"
                          options={feeTypeData}
                          value={
                            feeTypeData.filter((x) => x.value === feeType)
                              .length === 0
                              ? null
                              : feeTypeData.filter(
                                  (x) => x.value === feeType
                                )[0]
                          }
                          onChange={(e) => {
                            setFeeType(e === null ? "" : e.value);
                            handleSearchInputs(
                              "FeeType",
                              e != null ? e.value : ""
                            );
                            setResetStatus(false);
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Policy Term
                        </label>
                        <SelectInput
                          options={policyTermOptions}
                          value={searchPolicyTerm}
                          onChange={(e) => {
                            setsearchPolicyTerm(e);
                            handleSearchInputs(
                              "PolicyTerm",
                              e !== null ? e.value : ""
                            );
                            setResetStatus(false);
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Fee Level
                        </label>
                        <SelectInput
                          options={feeLevelOptions}
                          value={feeLevel}
                          onChange={(e) => {
                            setFeeLevel(e);
                            handleSearchInputs(
                              "FeeLevel",
                              e !== null ? e.label : ""
                            );
                            setResetStatus(false);
                          }}
                        />
                      </div>
                      <div className=""></div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Effective Date From
                        </label>
                        <DateInput
                          className="w-full"
                          value={dateFrom}
                          onChange={(e) => {
                            setDateFrom(e.target.value);
                            handleSearchInputs(
                              "EffectiveDateFrom",
                              e.target.value
                            );
                            setResetStatus(false);
                          }}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Effective Date To
                        </label>
                        <DateInput
                          className="w-full"
                          value={dateTo}
                          onChange={(e) => {
                            setDateto(e.target.value);
                            handleSearchInputs(
                              "EffectiveDateTo",
                              e.target.value
                            );
                            setResetStatus(false);
                          }}
                        />
                      </div>
                      <div className="flex flex-row gap-3 justify-center m-3">
                        <SearchButton
                          buttonValue="Search"
                          onClick={() => {
                            filterPolicyFee();
                          }}
                        />
                        <RefreshButton
                          onClick={() => {
                            refreshFilterTable();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
